import { gold, orange } from '@/theme/colors'
import styled from 'styled-components'

export const FormGroup = styled.div`
    margin-bottom: 1.25rem;

    &:last-child {
        margin-bottom: 0;
    }
`

export const FormLabel = styled.label`
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
`

export const CompactFormLabel = styled(FormLabel)`
    font-size: 12px;
    margin-bottom: 4px;
`

export const LocationSecondaryText = styled.div`
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 0.5rem;
    padding-left: 0.25rem;
`

export const FormInput = styled.input`
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`

export const FormTextArea = styled.textarea`
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    min-height: 100px;
    resize: vertical;
    font-family: inherit;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`

export const FormDescription = styled.p`
    font-size: 0.75rem;
    color: #9ca3af;
    margin: -4px 0 8px;
`

export const DateInputRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    @media (max-width: 500px) {
        grid-template-columns: 1fr;
    }
`

export const DateInputGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`

export const DateInput = styled.input`
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
    color-scheme: light;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
`

export const GuestsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
`

export const GuestRow = styled.div<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s;
    background: ${({ $isSelected }) => ($isSelected ? '#fef3e2' : 'transparent')};

    &:hover {
        background: ${({ $isSelected }) => ($isSelected ? '#fef3e2' : '#f9fafb')};
    }
`

export const GuestCheckbox = styled.div<{ $checked: boolean }>`
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid ${({ $checked }) => ($checked ? orange : '#d1d5db')};
    background: ${({ $checked }) => ($checked ? orange : 'white')};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.15s;

    &::after {
        content: '${({ $checked }) => ($checked ? '\\2713' : '')}';
        color: white;
        font-size: 12px;
        font-weight: 700;
    }
`

export const GuestName = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: #262626;
    flex: 1;
`

export const ProfileAvatar = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 600;
    flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const GuestSummary = styled.div`
    font-size: 0.75rem;
    color: #6b7280;
    margin-top: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: #f9fafb;
    border-radius: 6px;
`

export const GuestError = styled.span`
    color: #dc2626;
    font-weight: 500;
`

export const LinksSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const LinkRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

export const LinkInput = styled.input`
    flex: 1;
    padding: 10px 14px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &::placeholder {
        color: #9ca3af;
    }
`

export const RemoveLinkButton = styled.button`
    background: none;
    border: 1px solid #fca5a5;
    border-radius: 6px;
    color: #dc2626;
    cursor: pointer;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;

    &:hover {
        background: #fef2f2;
        border-color: #dc2626;
    }
`

export const AddLinkButton = styled.button`
    background: none;
    border: 1px dashed #d1d5db;
    border-radius: 8px;
    color: ${gold};
    cursor: pointer;
    padding: 0.625rem;
    font-size: 0.8125rem;
    font-weight: 500;
    transition: all 0.15s;

    &:hover {
        border-color: ${orange};
        color: ${orange};
        background: #fef3e2;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;

        &:hover {
            border-color: #d1d5db;
            color: ${gold};
            background: none;
        }
    }
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 1rem;
`

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' }>`
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    border: none;

    ${({ variant = 'secondary' }) => {
        switch (variant) {
            case 'primary':
                return `
                    background-color: ${orange};
                    color: white;

                    &:hover:not(:disabled) {
                        opacity: 0.9;
                    }

                    &:disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                `
            case 'danger':
                return `
                    background-color: #dc2626;
                    color: white;

                    &:hover:not(:disabled) {
                        background-color: #b91c1c;
                    }
                `
            default:
                return `
                    background-color: white;
                    color: #374151;
                    border: 1px solid #d1d5db;

                    &:hover {
                        background-color: #f3f4f6;
                    }
                `
        }
    }}
`
